import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Ranglijst", -1)
const _hoisted_2 = { class: "content-box" }
const _hoisted_3 = ["value"]

import {onMounted, ref} from 'vue';
	import {FetchData} from "../utils/FetchData";
	import {SortArrayByMultipleKeys} from "../utils/Sorting";
	import LoadingCircleAnimation from '../components/LoadingCircleAnimation.vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'LeaderboardPage',
  setup(__props) {

	const loading = ref(true);
	const seasons = ref([]);
	const selected = ref(0);
	const predictions = ref([]);
	const results = ref([]);
	const playerTotal = ref(new Map());

	let players = new Map();

	onMounted(() => {
		retrieveSeasons();
	})

	async function retrieveSeasons() {
		const data = await FetchData("user/seasons?with_players=1");
		if(!data.isError) {
			seasons.value = data.data;
			selected.value = seasons.value[seasons.value.length - 1].id;
			retrievePredictions();
		}
		else
			loading.value = false;
	}

	async function retrievePredictions() {
		if(selected.value == 0)
			return;

		loading.value = true;
		const data = await FetchData('predictions?season=' + selected.value);
		if(!data.isError) {
			predictions.value = SortArrayByMultipleKeys(data.data.predictions, ['race_id', 'player_id', 'position'], [false, false, false]);
			results.value = SortArrayByMultipleKeys(data.data.results, ['race_id', 'position'], [false, false]);
			calculateScores();
		}
		else
			loading.value = false;
	}

	function calculateScores() {
		//Clear scores and set players
		players.clear();
		playerTotal.value.clear();

		seasons.value.filter(x => x.id == selected.value)[0].players.forEach(player => {
			players.set(player.id, player.name);
		});

		players.forEach((value, key) => {
			playerTotal.value.set(key, 0);
		});

		//Iterate and compare scores to results
		const filteredPredictions = new Map();
		results.value.forEach(result => {
			let relevantPredictions;
			if(!filteredPredictions.has(result.race_id)) {
				relevantPredictions = predictions.value.filter(x => x.id == result.race_id);
				filteredPredictions.set(result.race_id, relevantPredictions);
			}
			else
				relevantPredictions = filteredPredictions.get(result.race_id);

			relevantPredictions.forEach(prediction => {
				let points = 0;
				if(prediction.driver_id == result.driver_id) {
					points += 1
					if(prediction.position == result.position)
						points += 3 - result.position;
				}

				points *= result.type + 1;
				points += playerTotal.value.get(prediction.player_id);

				playerTotal.value.set(prediction.player_id, points);
			});
		});

		//Sort players by total points
		const playersSorted = [];
		playerTotal.value.forEach((value, key) => {
			playersSorted.push({id: key, points: value, name: players.get(key).name});
		});

		const map = new Map();
		SortArrayByMultipleKeys(playersSorted, ['points', 'name'], [true, false]).forEach(value => {
			map.set(value.id, playerTotal.value.get(value.id));
		});

		playerTotal.value = map;
		loading.value = false;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (retrievePredictions()))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seasons.value, (season) => {
          return (_openBlock(), _createElementBlock("option", {
            key: season,
            value: season.id
          }, _toDisplayString(season.name), 9, _hoisted_3))
        }), 128))
      ], 544), [
        [_vModelSelect, selected.value]
      ])
    ]),
    (!loading.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(playerTotal.value, ([playerId, points]) => {
          return (_openBlock(), _createElementBlock("div", {
            key: playerId,
            class: "content-box leaderboard"
          }, [
            _createElementVNode("p", null, _toDisplayString(_unref(players).get(playerId)), 1),
            _createElementVNode("p", null, _toDisplayString(points), 1)
          ]))
        }), 128))
      : (loading.value)
        ? (_openBlock(), _createBlock(LoadingCircleAnimation, { key: 1 }))
        : _createCommentVNode("", true)
  ], 64))
}
}

})